import React from "react";

export const Eyebrow = ({ children, light = false }) => (
  <div className="flex items-center gap-3">
    <span className="h-[2px] w-8 bg-[#D4AF37]" />
    <span
      className={`font-display text-[11px] uppercase tracking-[0.35em] font-semibold ${
        light ? "text-white/80" : "text-[#0A192F]/70"
      }`}
    >
      {children}
    </span>
  </div>
);

export const SectionHeading = ({ eyebrow, title, subtitle, light = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow light={light}>{eyebrow}</Eyebrow>}
    <h2
      className={`font-display font-black tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-4 ${
        light ? "text-white" : "text-[#0A192F]"
      }`}
    >
      {title}
    </h2>
    {subtitle && (
      <p
        className={`mt-5 text-base leading-relaxed ${
          light ? "text-white/75" : "text-[#0A192F]/70"
        }`}
      >
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
